export default __webpack_public_path__ + "static/media/sidebar-item.6e93170e.svg";